export default "__VITE_ASSET__BaUAYrjt__"